import React from "react";
import { connect } from "react-redux";
import UserConnectedButton from "../UserConnectedButton";
import { useState } from "react";
import {
	INTEGRATION_TYPE,
	INTEGRATION_LOGO,
	INTEGRATION_NAME,
	INTEGRATION_VARIABLE,
	INTEGRATION_IN_PROGRESS as unfinished,
} from "@/integrations/smartPension/store/config.js";
import { Actions as ACTIONS } from "@/integrations/smartPension/store/smartPensionActions.js";

import {
	ArrowDownTrayIcon,
	ArrowPathIcon,
	BuildingOffice2Icon,
	ChevronDownIcon,
	Cog8ToothIcon,
	LinkIcon,
	MinusIcon,
	ViewColumnsIcon,
} from "@heroicons/react/20/solid";
import AsyncSelect from "react-select/async";
import { CustomOption } from "@/common/custom-selectors/CustomOption";
import { useMemo } from "react";
import Tooltip from "@/tooltip";
import { useEffect } from "react";

const SmartPensionSettings = ({
	connected,
	isAdvisor,
	connect,
	disconnect,
	userConnected,
	switchingOrganisation,
	companyName,
	resync,
	resyncing,
	connectionId,
	organisations,
	loadingOrganisations,
	disabled,
	updateConnectedOrg,
	getCompanyList,
	tokenId,
}) => {
	const [expand, setExpand] = useState(false);
	const [companyId, setCompanyId] = useState(null);
	const placeholder = useMemo(() => {
		if (switchingOrganisation) return "Linking Company...";
		if (!companyName) return;

		return (
			<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<div>{companyName}</div>
				<BuildingOffice2Icon style={{ height: "2rem", display: "block", paddingRight: "2rem" }} />
			</div>
		);
	}, [switchingOrganisation, companyName]);

	return (
		<div className={`${expand ? "tr-gray" : ""} col-xs-12 integration-row`}>
			<div className="col-xs-6">
				<img
					src={INTEGRATION_LOGO}
					width="40px"
				/>
				<span style={{ paddingLeft: 20, fontSize: 16 }}>{INTEGRATION_NAME}</span>
			</div>
			<div className="col-xs-6">
				{unfinished && !connected ? (
					<div className="btn btn-default pull-right">Coming Soon</div>
				) : (
					<div className="btn-group">
						{!userConnected && !connected && isAdvisor ? (
							<button
								className={`btn btn-${connected ? "default" : "primary"} pull-right`}
								onClick={() => {
									if (connected) setExpand(!expand);
									else connect("Advisor");
								}}
							>
								<ViewColumnsIcon style={{ height: "1.5em", float: "left" }} />
								<div style={{ float: "left", marginLeft: 5 }}>Connect Advisor</div>
							</button>
						) : null}
						{userConnected ? (
							<UserConnectedButton
								integration={userConnected}
								connectAdvisor={() => connect("Advisor")}
							/>
						) : null}
						{connected ? <div className="btn btn-default">Connected</div> : null}
						<button
							className={`btn btn-${connected ? "default" : "primary"} pull-right`}
							onClick={() => {
								if (connected) setExpand(!expand);
								else connect("Company");
							}}
						>
							{connected ? (
								<>
									<Cog8ToothIcon style={{ height: "1.5em", float: "left" }} />
									<div style={{ float: "left", marginLeft: 5 }}>Settings</div>
									<ChevronDownIcon
										style={{
											height: "1.5em",
											float: "left",
											transform: expand ? "rotate(180deg)" : "rotate(0deg)",
											transition: "transform 0.2s ease-in-out",
										}}
									/>
								</>
							) : (
								"Connect"
							)}
						</button>
					</div>
				)}
			</div>
			<div className="clearfix" />
			{expand && connected ? (
				<>
					<div
						className="row"
						style={{ paddingBottom: 0, paddingTop: "3rem" }}
					>
						<div className="col-xs-4 pr-0 pl-0">
							<div
								className="form-material form-container"
								style={{ position: "relative" }}
							>
								<label htmlFor="material-text">Company Link</label>
								{!userConnected && !connectionId ? (
									<Tooltip
										content={
											<a
												target="_blank"
												href="https://support.autoenrolment.co.uk/en/articles/3091672-setting-up-your-payroll-api"
											>
												Where do I find my Company ID?
											</a>
										}
									>
										<div className="input-group">
											<input
												className="form-input form-control"
												value={companyId}
												placeholder="Company ID"
												onChange={(e) => {
													setCompanyId(e.target.value);
												}}
											/>
											<span
												className="input-group-addon addon-success"
												onClick={() => {
													updateConnectedOrg(undefined, companyId);
												}}
												style={{ padding: "0 1rem", cursor: "pointer", background: "" }}
											>
												<LinkIcon className="w-7 h-7" />
											</span>
										</div>
									</Tooltip>
								) : (
									<AsyncSelect
										isDisabled={disabled || switchingOrganisation || !userConnected || (!tokenId)}
										isLoading={loadingOrganisations || switchingOrganisation}
										name="company"
										defaultOptions={organisations}
										menuPlacement="auto"
										components={{ Option: CustomOption }}
										classNamePrefix="react-select-search"
										placeholder={placeholder}
										onMenuOpen={getCompanyList}
										value={null}
										onChange={(selected) => {
											updateConnectedOrg(selected.label, selected.value);
										}}
									/>
								)}
							</div>
						</div>
						<div className="col-xs-8 pr-0 pl-0">
							<button
								style={{ marginTop: 13 }}
								className="btn btn-primary pull-right"
								onClick={() => {
									disconnect();
								}}
							>
								<MinusIcon style={{ height: "1.5em", float: "left" }} />
								<div style={{ float: "left", marginLeft: 5 }}>Disconnect</div>
							</button>
							<button
								disabled={disabled || resyncing}
								className="btn btn-default pull-right"
								type="button"
								style={{ marginRight: 10, marginTop: 13 }}
								onClick={() => resync()}
							>
								{resyncing ? (
									<ArrowPathIcon
										style={{ height: "1.5em", float: "left" }}
										className={`${resyncing ? "animate-spin" : ""}`}
									/>
								) : (
									<img
										src={INTEGRATION_LOGO}
										style={{ height: "1.5em", float: "left" }}
									/>
								)}
								<div style={{ float: "left", marginLeft: 5 }}>Resync{resyncing ? "ing..." : null}</div>
							</button>
							{/* <button
								style={{ marginTop: 13, marginRight: 10 }}
								className="btn btn-default pull-right"
								disabled={importingSchemes}
								onClick={() => {
									importSchemes();
								}}
							>
								{importingSchemes ? (
									<ArrowPathIcon
										style={{ height: "1.5em", float: "left" }}
										className="animate-spin"
									/>
								) : (
									<ArrowDownTrayIcon style={{ height: "1.5em", float: "left" }} />
								)}
								<div style={{ float: "left", marginLeft: 5 }}>
									Import{importingSchemes ? "ing" : null} Schemes
								</div>
							</button> */}
						</div>
					</div>
				</>
			) : null}
		</div>
	);
};

const mapStateToProps = (state) => {
	const integration = state.integration?.[INTEGRATION_TYPE]?.[INTEGRATION_VARIABLE] || {};
	const { connectionId, companyName, resyncing, companies, loadingOrganisations, switchingOrganisation, tokenId } =
		integration;

	return {
		isAdvisor: state.my?.profile?.advisorId,
		connectionId,
		companyName,
		organisations: companies,
		tokenId,
		loadingOrganisations,
		switchingOrganisation,
		resyncing,
		connected: !!integration?.id,
		userConnected: state.my?.integration?.[INTEGRATION_TYPE]?.[INTEGRATION_VARIABLE],
	};
};

const mapDispatchToProps = (dispatch) => ({
	connect: (type) => dispatch(ACTIONS.connectSmartPension(type)),
	disconnect: () => dispatch(ACTIONS.disconnectSmartPension()),
	resync: () => dispatch(ACTIONS.resyncDetails()),
	updateConnectedOrg: (companyName, organisationId) =>
		dispatch(ACTIONS.updateSmartPensionConnectedOrg({ companyName, organisationId })),
	getCompanyList: () => dispatch(ACTIONS.getCompanyList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SmartPensionSettings);
